<div class="cg-denied">
  <div class="cg-denied-card">
    <img src="assets/layout/images/cg-dark.svg" alt="Carreiras Galegas" class="cg-denied-brand" />

    <h1>Esto es el panel de la organización</h1>

    <p>
      Tu cuenta está bien, pero no administra carreras, así que aquí dentro no hay nada para ti.
      Si te has registrado para inscribirte en una prueba, lo tuyo está en la web.
    </p>

    <p class="cg-denied-who" *ngIf="email">
      Has entrado como <strong>{{ email }}</strong>.
    </p>

    <div class="cg-denied-actions">
      <!-- Cerrar la sesión, no «volver al inicio».
           El inicio, con la sesión abierta, redirige al dashboard y el guardián devuelve aquí: el
           botón dejaba a la persona dando vueltas sin forma de salir ni de entrar con otra cuenta. -->
      <button pButton type="button" label="Cerrar sesión" icon="pi pi-sign-out"
        [disabled]="leaving" (click)="signOut()"></button>

      <a pButton class="p-button-text" [href]="webUrl" icon="pi pi-external-link"
        label="Ir a Carreiras Galegas"></a>
    </div>
  </div>
</div>
